import { render, staticRenderFns } from "./createSetor.vue?vue&type=template&id=99d92b66&scoped=true"
import script from "./createSetor.vue?vue&type=script&lang=js"
export * from "./createSetor.vue?vue&type=script&lang=js"
import style0 from "./createSetor.vue?vue&type=style&index=0&id=99d92b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d92b66",
  null
  
)

export default component.exports